module.exports = __webpack_public_path__ + "img/AIAgent.f4269f92.svg";